import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'csl-radio-chip',
  standalone: true,
  imports: [],
  templateUrl: './radio-chip.component.html',
  styleUrl: './radio-chip.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioChipComponent {
  @Input() public label: string | number = '';
  @Input() public selected = false;
  @Input() public isDisabled = false;

  private readonly baseClasses =
    'py-2 px-5 md:py-3 md:px-4 min-w-[69px] text-center border rounded-xl cursor-pointer text-sm font-medium';

  public get classes(): string {
    if (this.isDisabled && this.selected) {
      return `${this.baseClasses} bg-gray-500 border-gray-500 text-gray-200`;
    }
    if (this.isDisabled && !this.selected) {
      return `${this.baseClasses} bg-gray-200 border-gray-200 text-gray-500`;
    }
    if (!this.isDisabled && this.selected) {
      return `${this.baseClasses} text-white border-blue-900 bg-blue-900 active:border-blue-800 active:bg-blue-800`;
    }
    return `${this.baseClasses} bg-white active:border-gray-500 active:bg-gray-200 border-gray-400`;
  }
}
